import React, { FC } from 'react';
import styled from 'styled-components';
import AppleIcon from '@westwing/ui-kit/Icons/AppleIcon';
import AndroidIcon from '@westwing/ui-kit/Icons/AndroidIcon';
import useBellaTranslator from '../../hooks/useTranslator';
import IconTray, { StyledLinkWrapper } from './IconTray';

const StyledAppleLinkWrapper = styled(StyledLinkWrapper)`
    height: 17px;
    width: 14px;
`;

const StyledAndroidLinkWrapper = styled(StyledLinkWrapper)`
    height: 16px;
    width: 14px;
`;

interface AppStoreProps {
    appleLink: string;
    androidLink: string;
}

const AppsStore: FC<AppStoreProps> = ({ appleLink, androidLink }) => {
    const t = useBellaTranslator();
    return (
        <IconTray>
            <StyledAppleLinkWrapper href={appleLink} title={t('Appstore download link')}>
                <AppleIcon />
            </StyledAppleLinkWrapper>
            <StyledAndroidLinkWrapper href={androidLink} title={t('Playstore download link')}>
                <AndroidIcon />
            </StyledAndroidLinkWrapper>
        </IconTray>
    );
};

export default AppsStore;
